import { Component, Injectable, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-dropdown',
  template: `
  <button type="button" class="btn blue-btn btn-sm ml-2" (click)="RefreshDropDownValues()" style="border-radius: 90%">
  <i class="fa fa-refresh"></i>
</button>
  `
})
export class DropdownComponent {
  @Output() EmitRefreshClick = new EventEmitter();
  constructor() {
  }
  ngOnInit(): void {
  }
  RefreshDropDownValues() {
    this.EmitRefreshClick.emit();
  }
}
